export default __webpack_public_path__ + "static/media/3reason-why.a4fc3ccb.png";